var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"my-modal",attrs:{"hide-footer":"","title":_vm.plain_file.filename}},[_c('div',[_vm._v(_vm._s(_vm.plain_file.header))]),_vm._l((_vm.plain_file.pallets),function(item){return _c('div',[_vm._v(_vm._s(item))])}),_c('div',[_vm._v("&&")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }